import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiModule } from '@lockton-apps/shared/ui/lui';
import { MaterialModule } from '@lockton-apps/material';
import { CobMetaPipe } from '@lockton-apps/shared/ui/pipes';
import { LetDirective } from '@ngrx/component';

@Component({
    selector: 'la-proposal-offline-products',
    imports: [CommonModule, UiModule, MaterialModule, CobMetaPipe, LetDirective],
    templateUrl: './proposal-offline-products.component.html',
    styleUrls: ['./proposal-offline-products.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProposalOfflineProductsComponent {
  @Input() title!: string;
  @Input() productIds!: string[];
}
